import { API } from '@/src/api/api'
import type { LoadPlanningControllerRequestLoadProfileDataData } from '@/src/api/types/procurement'
import { useMutation } from '@tanstack/react-query'

export const useRequestLoadProfile = () => {
  return useMutation({
    mutationFn: async (data: LoadPlanningControllerRequestLoadProfileDataData) => {
      return API.procurements.requestLoadProfile(data)
    },
  })
}
